import React, { forwardRef, memo } from 'react'

const CursorIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="36.4"
      height="36.4"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
      fill="none"
      stroke="#78BE20"
      strokeWidth={3.227}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}>
      <path d="M32.978 28.103a2.3 2.3 0 0 1-.405-.671c-.078-.253-.093-.521-.044-.782s.162-.505.327-.712a2.3 2.3 0 0 1 .622-.476l9.427-3.62a2.3 2.3 0 0 0 .715-.632 2.3 2.3 0 0 0 .236-1.124 2.3 2.3 0 0 0-.324-1.258 2.3 2.3 0 0 0-.772-.561L10.246 8.209a2.3 2.3 0 0 0-1.233-.025 2.3 2.3 0 0 0-.757.429 2.3 2.3 0 0 0-.465.757 2.3 2.3 0 0 0-.024 1.229l10.612 32.52a2.3 2.3 0 0 0 .561.772 2.3 2.3 0 0 0 1.258.324 2.3 2.3 0 0 0 1.124-.236 2.3 2.3 0 0 0 .632-.715l3.62-9.427a2.3 2.3 0 0 1 .476-.622 2.3 2.3 0 0 1 .712-.327 2.3 2.3 0 0 1 .782.044c.253.078.483.217.67.405l10.423 10.422a2.3 2.3 0 0 0 3.252 0l2.578-2.571a2.3 2.3 0 0 0 0-3.252L32.978 28.103Z" />
    </svg>
  )
)

CursorIcon.displayName = 'CursorIcon'
export default memo(CursorIcon)
